import { CSSProperties } from 'react';

import { themeByService } from '@repo/styles';
import cn from 'classnames';

import { IThrillIconProps, ThrillIconVariant } from '.';

function BubbleChatThrillIcon({
  color = themeByService().color.static.adult.light,
  className,
  size = 24,
  rotate,
  flip,
  variant = ThrillIconVariant.DEFAULT,
  style,
}: IThrillIconProps) {
  const defaultStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 100,
    border: `1.2px solid ${color}`,
    background: '#FFF',
  };

  const mergedStyle = {
    width: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
    ...(variant === ThrillIconVariant.DEFAULT ? defaultStyle : {}),
    ...style,
  };
  return (
    <i className={cn('dds-icon', className, { flip })} style={mergedStyle}>
      {variant === ThrillIconVariant.DEFAULT && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          className="thrill-lighting-icon"
          // 글로벌 .dds-icon svg { align-self: stretch }가 고정 크기 svg를 flex-start(위쪽)로 밀어
          // 번개가 배지 위로 치우치던 문제 → 중앙 정렬로 override
          style={{ alignSelf: 'center' }}
        >
          <path
            d="M11.5729 6.4892C11.5574 6.42203 11.5255 6.35976 11.4801 6.30795C11.4346 6.25614 11.377 6.21641 11.3125 6.19232L8.31247 5.06732L9.07289 1.24961C9.09038 1.16118 9.07908 1.06947 9.04065 0.987926C9.00222 0.906382 8.93868 0.839292 8.85935 0.796488C8.77923 0.75387 8.68727 0.738934 8.59778 0.754006C8.50829 0.769078 8.42629 0.813311 8.36455 0.879821L2.53122 7.12982C2.48342 7.17941 2.44884 7.24021 2.43064 7.30664C2.41244 7.37307 2.41121 7.443 2.42705 7.51003C2.44336 7.57682 2.47555 7.63869 2.52089 7.69037C2.56623 7.74206 2.62337 7.78203 2.68747 7.8069L5.68747 8.9319L4.92705 12.7496C4.90957 12.838 4.92087 12.9298 4.95929 13.0113C4.99772 13.0928 5.06126 13.1599 5.1406 13.2027C5.2004 13.2329 5.26633 13.2489 5.3333 13.2496C5.3899 13.2499 5.44595 13.2384 5.49792 13.216C5.5499 13.1936 5.5967 13.1607 5.63539 13.1194L11.4687 6.8694C11.5165 6.81981 11.5511 6.75902 11.5693 6.69259C11.5875 6.62616 11.5887 6.55622 11.5729 6.4892Z"
            fill={color}
          />
        </svg>
      )}
      {variant === ThrillIconVariant.ONLY_ICON && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
          <path
            d="M16.0965 9.3217C16.0759 9.23216 16.0334 9.14913 15.9728 9.08006C15.9122 9.01098 15.8354 8.95802 15.7494 8.92591L11.7498 7.42607L12.7636 2.33633C12.7869 2.21843 12.7718 2.09616 12.7206 1.98745C12.6693 1.87873 12.5846 1.78929 12.4789 1.73222C12.3721 1.67541 12.2495 1.65549 12.1301 1.67559C12.0108 1.69568 11.9015 1.75465 11.8192 1.84332L4.04226 10.1758C3.97854 10.2419 3.93243 10.3229 3.90817 10.4115C3.8839 10.5001 3.88226 10.5933 3.90339 10.6827C3.92513 10.7717 3.96804 10.8542 4.02849 10.9231C4.08893 10.992 4.16512 11.0453 4.25057 11.0785L8.25015 12.5783L7.23637 17.668C7.21305 17.7859 7.22812 17.9082 7.27935 18.0169C7.33058 18.1256 7.41529 18.2151 7.52106 18.2721C7.60079 18.3124 7.68868 18.3337 7.77798 18.3346C7.85344 18.335 7.92815 18.3197 7.99745 18.2898C8.06674 18.26 8.12913 18.2161 8.18071 18.161L15.9577 9.82859C16.0214 9.76247 16.0675 9.68142 16.0918 9.59286C16.116 9.5043 16.1177 9.41106 16.0965 9.3217Z"
            fill={color || themeByService().color.static.adult.light}
          />
        </svg>
      )}
      {variant === ThrillIconVariant.SIDE_MENU && (
        <svg viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="13" height="13" rx="6.5" fill={color} />
          <path
            d="M9.58643 6.15563C9.57599 6.11029 9.55446 6.06826 9.52379 6.03329C9.49311 5.99831 9.45423 5.9715 9.41065 5.95524L7.38564 5.19586L7.89892 2.61891C7.91073 2.55922 7.9031 2.49731 7.87716 2.44227C7.85122 2.38723 7.80833 2.34194 7.75478 2.31305C7.7007 2.28428 7.63863 2.2742 7.57822 2.28438C7.51782 2.29455 7.46247 2.32441 7.4208 2.3693L3.48328 6.58805C3.45102 6.62152 3.42767 6.66256 3.41539 6.7074C3.4031 6.75224 3.40227 6.79945 3.41297 6.84469C3.42398 6.88978 3.4457 6.93154 3.47631 6.96642C3.50691 7.00131 3.54548 7.0283 3.58875 7.04508L5.61376 7.80446L5.10047 10.3814C5.08867 10.4411 5.0963 10.503 5.12224 10.558C5.14818 10.6131 5.19106 10.6584 5.24462 10.6873C5.28498 10.7076 5.32948 10.7185 5.37469 10.7189C5.4129 10.7191 5.45073 10.7114 5.48581 10.6962C5.5209 10.6811 5.55249 10.6589 5.5786 10.631L9.51612 6.41227C9.54838 6.3788 9.57172 6.33776 9.58401 6.29292C9.59629 6.24808 9.59713 6.20087 9.58643 6.15563Z"
            fill="white"
          />
        </svg>
      )}
      {variant === ThrillIconVariant.SIDE_MENU_NO_FILL && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
          <path
            d="M12.5941 0.837737C12.8123 0.819285 13.0319 0.85502 13.233 0.941611L13.3317 0.989439L13.3361 0.991681L13.4281 1.04623C13.6083 1.16289 13.7578 1.32103 13.8645 1.50732L13.9146 1.60222L13.9564 1.70162C14.0446 1.93576 14.0658 2.19085 14.0169 2.4377V2.43845L13.0963 7.059L16.6183 8.38023H16.619C16.7747 8.4383 16.9179 8.52451 17.0413 8.63431L17.1578 8.75164L17.2587 8.88242C17.3516 9.01915 17.4187 9.17252 17.456 9.33453H17.4553C17.5055 9.55018 17.5018 9.77483 17.4433 9.98842C17.3855 10.1994 17.2759 10.3923 17.1257 10.5511L17.1264 10.5519L9.09148 19.1608L9.08999 19.1615C8.96475 19.2953 8.8136 19.4021 8.64534 19.4746C8.47713 19.5471 8.2957 19.5838 8.11252 19.583H8.10804C7.95104 19.5814 7.79581 19.5533 7.64919 19.4993L7.50571 19.4365L7.48703 19.4268C7.23386 19.2902 7.03051 19.0765 6.90787 18.8163C6.78524 18.556 6.74968 18.263 6.80549 17.9808V17.98L7.72542 13.3587L4.20265 12.0375L4.19443 12.0345C3.99139 11.9557 3.81049 11.8291 3.66684 11.6654C3.52315 11.5016 3.42109 11.3053 3.36941 11.0937L3.36792 11.0884C3.31663 10.8715 3.32027 10.645 3.37913 10.4301L3.43368 10.2724C3.49578 10.1224 3.58527 9.9851 3.69748 9.86661H3.69673L11.7317 1.25772C11.9314 1.04329 12.196 0.900635 12.485 0.851936L12.5941 0.837737ZM5.00674 10.7051L8.87178 12.1541C9.22284 12.2857 9.42702 12.6525 9.35378 13.0202L8.43834 17.6169L15.8149 9.71267L11.9507 8.2644C11.5996 8.13277 11.3955 7.76595 11.4686 7.39828L12.3841 2.80015L5.00674 10.7051ZM16.1497 9.6342L16.149 9.63495L15.9644 9.67754C15.9647 9.67872 15.9656 9.6801 15.9659 9.68128L16.1579 9.63569L16.7102 9.50641L16.1557 9.63345L16.1512 9.6342H16.1497Z"
            fill={color}
          />
        </svg>
      )}
    </i>
  );
}

export default BubbleChatThrillIcon;
